import { render, staticRenderFns } from "./Highscore.vue?vue&type=template&id=50e4dc5e&scoped=true&"
import script from "./Highscore.vue?vue&type=script&lang=js&"
export * from "./Highscore.vue?vue&type=script&lang=js&"
import style0 from "./Highscore.vue?vue&type=style&index=0&id=50e4dc5e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e4dc5e",
  null
  
)

export default component.exports